import { getApiErrorHttpStatus, getApiErrorMessage } from '@mi-front/core';
import { ReportError } from './report-error';

const DEFAULT_REPORT_FAILURE_MESSAGE =
  'Ocurrió un error al generar el reporte, por favor intente nuevamente';

const REPORT_FAILURE_WITH_REASON_PREFIX = 'Ocurrió un error al generar el reporte';

/**
 * Resolves the toast message for a failed report run.
 * Prefer `ReportError`, then a 400 API `message`, otherwise the generic fallback.
 */
export function resolveReportFailureMessage(error: unknown): string {
  if (error instanceof ReportError) {
    return error.message;
  }

  if (getApiErrorHttpStatus(error) === 400) {
    const apiMessage = getApiErrorMessage(error);
    if (apiMessage) {
      return `${REPORT_FAILURE_WITH_REASON_PREFIX}: ${apiMessage}`;
    }
  }

  return DEFAULT_REPORT_FAILURE_MESSAGE;
}
